import Vue from 'vue';
import Vuex from 'vuex';
import apiModule from './modules/api';
import detailsModule from './modules/details';
import loginModule from './modules/login';
import tPassTokenModule from './modules/tPassToken';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    api: apiModule,
    details: detailsModule,
    login: loginModule,
    tPassToken: tPassTokenModule
  },
});
